module.exports = __webpack_public_path__ + "img/first.b6a8bd24.png";